/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Outlook_Ingest_AttachmentsInputs */

const es_tools_outlook_ingest_attachments = /** @type {(inputs: Tools_Outlook_Ingest_AttachmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingestando adjuntos de Outlook...`)
};

const en_tools_outlook_ingest_attachments = /** @type {(inputs: Tools_Outlook_Ingest_AttachmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingesting Outlook attachments...`)
};

/**
* | output |
* | --- |
* | "Ingesting Outlook attachments..." |
*
* @param {Tools_Outlook_Ingest_AttachmentsInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_outlook_ingest_attachments = /** @type {((inputs?: Tools_Outlook_Ingest_AttachmentsInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Outlook_Ingest_AttachmentsInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_outlook_ingest_attachments(inputs)
	return en_tools_outlook_ingest_attachments(inputs)
});
export { tools_outlook_ingest_attachments as "tools.outlook.ingest_attachments" }